import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

const { tabs: tabStrings } = appStrings.modules.coachingAnalytics;

/** URL segment after `/coaching-analytics/`. Overview is the bare path. */
export const ANALYTICS_TAB_SLUG = {
  overview: '',
  blueprint: 'blueprint',
  onTrack: 'on-track',
  lifeReadiness: 'life-readiness',
  engagement: 'engagement',
  coaching: 'coaching',
} as const;

export type AnalyticsTab = keyof typeof ANALYTICS_TAB_SLUG;

export const ANALYTICS_TAB_LABEL: Readonly<Record<AnalyticsTab, string>> = {
  overview: tabStrings.overview,
  blueprint: tabStrings.blueprint,
  onTrack: tabStrings.onTrack,
  lifeReadiness: tabStrings.lifeReadiness,
  engagement: tabStrings.engagement,
  coaching: tabStrings.coaching,
};

export const ANALYTICS_TABS = Object.keys(ANALYTICS_TAB_SLUG) as readonly AnalyticsTab[];

export const analyticsTabFromSlug = (slug: string | undefined): AnalyticsTab | null => {
  if (!slug) return 'overview';

  return ANALYTICS_TABS.find((tab) => ANALYTICS_TAB_SLUG[tab] === slug) ?? null;
};

export const analyticsTabPath = (base: string, tab: AnalyticsTab): string =>
  tab === 'overview' ? base : `${base}/${ANALYTICS_TAB_SLUG[tab]}`;
